import { Box } from "@mui/material";
import { useMemo } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { LIST_SOUS_MENU_USAGER } from "./data";
import './SousMenu.style.scss';

export const SousMenuUsager = () => {
    const menus = useMemo(() => {
        return LIST_SOUS_MENU_USAGER;
    }, []);

    const location = useLocation();

    return (
        <>
            <Box>
                <div className="div-sous-menu">
                    {menus.map((menu, key) => 
                        <Link
                            key={key}
                            className={location.pathname.includes(`/admin/usager/${menu.key}`) ? 'item-sous-menu active' : 'item-sous-menu'}
                            to={`/admin/usager/${menu.key}`}
                        >
                            {menu.name}
                        </Link>
                    )}
                </div>
            </Box>
            <Outlet/>
        </>
    )
}